import React from "react";
import { FeatureFlag } from "@rentablo/theming";
import { useFeatureFlag } from "@hooks";
import {
  MenuItemExpandable,
  MenuItemExpandableProps,
} from "./MenuItemExpandable";

interface Props extends MenuItemExpandableProps {
  featureFlag: FeatureFlag;
}

export const FeatureFlagMenuItemExpandable = ({
  featureFlag,
  ...props
}: Props) => {
  const isFlagEnabled = useFeatureFlag(featureFlag);

  if (!isFlagEnabled) {
    return null;
  }

  return <MenuItemExpandable {...props} />;
};
